export default __webpack_public_path__ + "static/printer_b.9f3dba0283c3bd75c8e6602f5145e267.svg";